var CONST_ACTIONCODES = require('../../constants/actionCodes'),
  CONST_ERRORS = require('../../constants/errors');

function MalformedJwtError(){
  this.ActionCode = CONST_ACTIONCODES.ERROR;
	this.ErrorNumber = CONST_ERRORS.MALFORMED_JWT.NUMBER;
	this.ErrorDescription = CONST_ERRORS.MALFORMED_JWT.DESCRIPTION;
	this.Validated = false;
}

MalformedJwtError.prototype = new Error();
MalformedJwtError.prototype.name = "MalformedJwtError";
MalformedJwtError.prototype.constructor = MalformedJwtError;

module.exports = MalformedJwtError;


//////////////////
// WEBPACK FOOTER
// ./models/errors/malformedJwtError.js
// module id = 53
// module chunks = 0 5 20